import { Notification } from '../../models/notification';

export type NotificationState = {
  notifications: Notification[];
};

export const initialState: NotificationState = {
  notifications: [],
};
